import { useAuth0 } from '@auth0/auth0-react';
import useSWRMutation from 'swr/mutation';
import http from '@/Utils/HTTP/NewHttpUtils';

const useSubmitEmailSetupAccessCode = (companyId: string | null) => {
    const { getAccessTokenSilently } = useAuth0();

    return useSWRMutation(
        // Only fetch when both companyId and code are available (conditional fetching)
        // SWR will skip the request if the key is null/undefined/false
        companyId ? `company/${companyId}/settings/email-connection/submit-code` : null,
        async (path: string, { arg }: { arg: string }) => {
            await http.post({
                path,
                accessToken: await getAccessTokenSilently(),
                body: { code: arg },
            });
        },
    );
};

export default useSubmitEmailSetupAccessCode;
